/* eslint-disable */
import types from "../actions/types/types";
import {
  omit,
  cloneDeep,
  findIndex,
  some,
  pick,
  isEmpty,
  mapKeys,
  sortBy,
  reduce,
} from "lodash";
import { RATE_SCORE } from "utils/CONSTANTS";

const newJSON = {
  uid: "",
  data: {},
};

const initialState = {
  scroll: true,
  sessionId: null,
  sessions: {},
  rateParam: null,
  user: {
    uid: "",
    identification: null,
    loading: false,
    error: null,
  },
  widgetJSON: {
    uid: "",
    isLinkActive: false,
    loading: false,
    error: null,
    data: null,
  },
  pages: null,
  maxPage: 0,
  currentPage: 0,
  steps: [],
  isFinal: false,
  tempFeedbackScore: 0,
  buttonPressed: "next_button",
  condition: [],
  past: {},
  selectedLanguage: "en",
  formValues: {
    customer_data: {},
  },
  customFormValues: {
    customer_data: {
      datepicker: "29-11-1990",
    },
    custom_field_feedback_component: {},
  },
  feedbackArray: [],
  currentFeedbackScore: null,
  overallFeedbackScores: null,
  markpage: {
    show: false,
    data: null,
    serviceId: null,
    rate: null,
  },
  isMultiService: false,
  serviceIds: [],
  pageComponents: [],
  collectedFeedback: {
    loading: false,
    error: null,
  },
  pageCondition: {},
  isErrorPage: false,
  buttonsDisable: false,
  isRTL: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SESSION_ID: {
      const { condition: stateCondition = [], selectedLanguage } = { ...state };
      const {
        sessions = {},
        sessionId,
        condition = stateCondition,
      } = action.data;
      return {
        ...state,
        sessionId,
        selectedLanguage: action.lang || selectedLanguage,
        sessions,
        condition,
      };
    }
    case types.SET_RATE_PARAM: {
      return {
        ...state,
        rateParam: action.data,
      };
    }
    case types.FETCH_WIDGET_JSON_STARTED: {
      return {
        ...state,
        widgetJSON: {
          ...state.widgetJSON,
          loading: true,
          error: null,
        },
      };
    }
    case types.FETCH_WIDGET_JSON_SUCCESS: {
      const { rateParam } = state;
      try {
        // const { data, uid } = newJSON;
        const { data, uid } = action.data;
        const { is_kiosk_mode = false } = data.general_settings_data || {};
        let newCurrentPage = 0;
        let selectedLanguage = "en";
        const pages = omit(data, [
          "general_settings",
          "markpage_data",
          "form_errors",
        ]);

        let serviceIds = [];
        const ordered = Object.keys(pages)
          .sort()
          .reduce((obj, key) => {
            obj[key] = pages[key];
            if (pages[key].sli_data && rateParam) {
              console.log();
              pages[key].sli_data.attrs.service.map((item) => {
                serviceIds.push(item.id);
              });
            }

            if (pages[key].languages) {
              const { languages = [] } = pages[key];
              if (languages.length <= 1) {
                newCurrentPage = 1;
              }

              if (languages.length === 1) {
                selectedLanguage = languages[0].lang_code;
              }
            }

            //Temp
            // if (obj[key].sli_data) {
            //   obj[key].sli_data.attrs.service = [pages[key].sli_data.attrs.service[0]]
            // }

            return obj;
          }, {});

        const { general_settings = {} } = data;

        return {
          ...state,
          uid: uid,
          selectedLanguage,
          serviceIds,
          currentPage: newCurrentPage,
          isKioskMode: is_kiosk_mode,
          widgetJSON: {
            ...state.widgetJSON,
            loading: false,
            data: {
              ...data,
              general_settings: {
                ...general_settings,
                error_messages: general_settings.form_errors,
              },
            },
            isLinkActive: true,
          },
          pages: ordered,
          //-2 because of final_page_data
          maxPage: Object.keys(ordered).length - 2,
        };
      } catch (error) {
        console.log(error);
        return state;
      }
    }
    case types.FETCH_WIDGET_JSON_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    }
    case types.SELECT_LANGUAGE: {
      const { lang, ltr } = action.data;
      return {
        ...state,
        selectedLanguage: lang,
        isRTL: !ltr,
      };
    }
    case types.SUBMIT:
      return { ...state, ...action.data };
    case types.NEXT_PAGE: {
      const {
        currentPage,
        maxPage,
        currentFeedbackScore,
        tempFeedbackScore,
        pages,
        feedbackArray,
        condition,
        steps,
        pageCondition,
      } = state;
      // let nextPage = currentPage;
      // if (currentPage <= maxPage) {
      //   nextPage++;
      // }

      let feedbackScore = null;
      const currentPageComponent = pages[currentPage];
      const { next_page } = currentPageComponent || {};
      let newCurrentPage;
      let newSteps = [...steps, currentPage];
      if (next_page) {
        newCurrentPage = next_page;
      } else if (currentPage === 0) {
        newCurrentPage = 1;
      } else {
        const { overall } = condition[0] || {};
        const {
          positive: { page: positionPage },
          neutral: { page: neutralPage },
          negative: { page: negativePage },
        } = overall || {};

        if (
          pageCondition[currentPage] &&
          !isEmpty(pageCondition[currentPage])
        ) {
          const pageFeedback = pageCondition[currentPage];
          newCurrentPage = pageFeedback.every(
            (item) => item.conditionType === "positive"
          )
            ? positionPage
            : feedbackArray.some((item) => item.conditionType === "negative")
            ? negativePage
            : neutralPage;
        } else {
          newCurrentPage = positionPage;
        }
        // if (!isEmpty(feedbackArray)) {
        //   newCurrentPage = feedbackArray.every(
        //     (item) => item.conditionType === "positive"
        //   )
        //     ? positionPage
        //     : feedbackArray.some((item) => item.conditionType === "negative")
        //     ? negativePage
        //     : neutralPage;
        // } else {
        //   newCurrentPage = positionPage;
        // }
      }

      return {
        ...state,
        currentPage: newCurrentPage,
        steps: newSteps,
        currentFeedbackScore: feedbackScore,
        tempFeedbackScore: 0,
        buttonPressed: "next_button",
      };
    }
    case types.PREVIOUS_PAGE: {
      const { currentPage, pages, steps } = state;
      let prevPage = state.steps[state.steps.length - 1];
      steps.pop();
      let newSteps = steps;
      // console.log(pages);
      // let previousPage = 0;

      // if (currentPage > 0) {
      //   previousPage = currentPage - 1;
      // }

      return {
        ...state,
        // currentPage: previousPage,
        currentPage: prevPage,
        steps: newSteps,
        buttonPressed: "back_button",
        isFinal: false,
      };
    }
    case types.SAVE_FORM_VALUES: {
      const { customer_data: prevCustomerData } = state.formValues;
      const { customer_data: newCustomerData } = action.data;
      return {
        ...state,
        formValues: {
          ...state.formValues,
          ...action.data,
          customer_data: {
            ...prevCustomerData,
            ...newCustomerData,
          },
        },
        buttonPressed: "next_button",
      };
    }
    case types.ADD_TO_CUSTOM_FORM_VALUES: {
      const { component, data } = action.data;

      return {
        ...state,
        customFormValues: {
          ...state.customFormValues,
          [component]: {
            ...state.customFormValues[component],
            ...data,
          },
        },
      };
    }
    case types.SHOW_MARKPAGE: {
      const { markpage, rate, serviceId } = action.data;
      return {
        ...state,
        markpage: {
          ...state.markpage,
          show: true,
          data: markpage,
          rate: rate,
          serviceId: serviceId,
        },
      };
    }
    case types.CLOSE_MARKPAGE: {
      return {
        ...state,
        markpage: {
          ...state.markpage,
          show: false,
          data: null,
          rate: null,
          serviceId: null,
        },
      };
    }
    case types.SAVE_FEEDBACK: {
      let {
        feedbackArray: newFeedbackArray,
        currentPage,
        isMultiService,
        condition,
        isFinal,
      } = cloneDeep(state);
      const { serviceId, rate, marks = [], markpage } = action.data;
      console.log(markpage);
      try {
        const index = findIndex(newFeedbackArray, ["serviceId", serviceId]);
        const pickedMarkIds = [];
        marks.map((mark) => pickedMarkIds.push(mark));

        const conditionTypes = {
          excellent: "positive",
          good: "positive",
          neutral: "neutral",
          bad: "negative",
          very_bad: "negative",
          unacceptable: "negative",
        };

        const serviceWithFeedback = {
          serviceId: serviceId,
          mark_page: markpage ? markpage.data.id : null,
          rate,
          conditionType: conditionTypes[rate],
          marks: pickedMarkIds,
          page: currentPage,
        };

        if (index === -1) {
          newFeedbackArray.push(serviceWithFeedback);
        }
        // else if (rate === newFeedbackArray[index].rate) {
        //   newFeedbackArray = newFeedbackArray.filter(
        //     (feedback) => feedback.serviceId !== serviceId
        //   );
        // }
        else {
          newFeedbackArray[index] = serviceWithFeedback;
        }

        const currentScore = reduce(
          newFeedbackArray,
          function (sum, n) {
            console.log(sum, RATE_SCORE[n.rate], n.rate);
            if (n.page === currentPage) {
              return RATE_SCORE[n.rate] + sum;
            }
          },
          0
        );

        let sessionRate = "positive";
        let allow = true;
        Object.keys(conditionTypes)
          .reverse()
          .forEach((key) => {
            if (
              newFeedbackArray.some((feedback) => feedback.rate === key) &&
              allow
            ) {
              sessionRate = conditionTypes[key];
              allow = false;
            }
          });
        const newSessions = cloneDeep(state.sessions);
        Object.values(newSessions).map((value) => {
          if (value.rate) {
            value.rate = sessionRate;
          }
        });

        let newPageCondition = {};
        let pageFeedback = state.pageCondition[currentPage];
        if (pageFeedback && pageFeedback.length > 0) {
          pageFeedback = pageFeedback.filter(
            (item) => item.serviceId !== serviceWithFeedback.serviceId
          );
          newPageCondition = {
            ...state.pageCondition,
            [currentPage]: [...pageFeedback, serviceWithFeedback],
          };
        } else {
          newPageCondition = {
            ...state.pageCondition,
            [currentPage]: [serviceWithFeedback],
          };
        }

        const { overall = {} } = condition[0] || {};
        if (Object.keys(overall).find((key) => overall[key].page === 1000)) {
          const isNegative = newPageCondition[currentPage].some(
            (feedback) => feedback.conditionType === "negative"
          );
          const isNeutral = newPageCondition[currentPage].some(
            (feedback) => feedback.conditionType === "neutral"
          );
          isFinal = isNegative
            ? overall?.negative?.page === 1000
              ? true
              : false
            : isNeutral
            ? overall.neutral?.page === 1000
              ? true
              : false
            : overall?.positive?.page === 1000
            ? true
            : false;
        }

        return {
          ...state,
          sessions: newSessions,
          feedbackArray: newFeedbackArray,
          tempFeedbackScore: currentScore,
          markpage: {
            ...state.markpage,
            show: false,
            data: null,
            rate: null,
            serviceId: null,
          },
          isFinal,
          pageCondition: newPageCondition,
        };
      } catch (err) {
        console.log(err);
        return state;
      }
    }
    case types.RESET_CURRENT_FEEDBACK_SCORE: {
      const { feedbackArray, currentPage } = state;

      if (action.data) {
        return {
          ...state,
          currentFeedbackScore: action.data,
        };
      } else {
        const currentScore = calculateCurrentScore(feedbackArray, currentPage);
        return {
          ...state,
          currentFeedbackScore: currentScore,
        };
      }
    }

    case types.SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.data,
      };
    }

    case types.IS_SLI_MULTI_SERVICE: {
      return {
        ...state,
        isMultiService: action.data,
      };
    }
    case types.GENERATE_PAGE_COMPONENTS: {
      const { pages, currentPage } = { ...state };
      // console.log(action.data);
      try {
        let pageComponents = [];
        let condition = [];
        let isFinal = false;
        // let nextPage = currentPage + 1;
        // let prevPage = currentPage;
        const page = pages[currentPage];
        const customFields = pick(page, "custom_field_feedback_component");
        const languages = pick(page, "languages");
        const { condition: pageCondition, next_page = null } = page || {};
        const omittedPage = omit(page, [
          "properties",
          "custom_field_feedback_component",
          "condition",
          "next_page",
          "prev_page",
        ]);

        if (!isEmpty(languages)) {
          return state;
        }
        if (
          next_page &&
          next_page === 1000
          // pageCondition.overall.positive.page === 1000
        ) {
          isFinal = true;
        }

        //My changes
        if (!isEmpty(customFields)) {
          customFields.custom_field_feedback_component.attrs.map((item) => {
            item.componentType = "custom_field_feedback_component";
            pageComponents.push(item);
          });
        }

        mapKeys(omittedPage, (value, key) => {
          value.componentType = key;
          pageComponents.push(value);
        });

        const sortedComponents = sortBy(pageComponents, ["position"]);
        if (!isEmpty(pageCondition)) condition.push(pageCondition);
        return {
          ...state,
          pageComponents: sortedComponents,
          condition,
          isFinal,
        };
      } catch (err) {
        console.log(err);
        return state;
      }
    }
    case types.FETCH_IDENTIFICATION_STARTED: {
      return {
        ...state,
        collectedFeedback: {
          ...state.collectedFeedback,
          loading: true,
          error: null,
        },
      };
    }
    case types.FETCH_IDENTIFICATION_SUCCESS: {
      return {
        ...state,
        collectedFeedback: {
          ...state.collectedFeedback,
          loading: false,
          identification: action.data,
        },
      };
    }
    case types.FETCH_IDENTIFICATION_FAILURE: {
      return {
        ...state,
        collectedFeedback: {
          ...state.collectedFeedback,
          loading: false,
          error: null,
        },
      };
    }
    case types.FETCH_SEND_COLLECTED_FEEDBACK_STARTED: {
      return {
        ...state,
        collectedFeedback: {
          ...state.collectedFeedback,
          loading: true,
          error: null,
        },
      };
    }
    case types.FETCH_SEND_COLLECTED_FEEDBACK_SUCCESS: {
      return {
        ...state,
        collectedFeedback: {
          ...state.collectedFeedback,
          loading: false,
        },
      };
    }
    case types.FETCH_SEND_COLLECTED_FEEDBACK_FAILURE: {
      return {
        ...state,
        collectedFeedback: {
          ...state.collectedFeedback,
          loading: false,
          error: action.data,
        },
      };
    }
    case types.UPDATE_CONDITION: {
      const {
        feedbackArray,
        condition = [],
        currentPage,
        pageComponents = [],
      } = state;

      // const newCondition = cloneDeep(condition[currentPage]) || {}
      const newCondition = {};
      const conditionPlaceholder = {
        positive: "",
        neutral: "",
        negative: "",
        page: currentPage,
      };
      const sliExists = some(pageComponents, ["componentType", "sli_data"]);
      const conditionIndex = findIndex(condition, ["page", currentPage]);

      if (sliExists) {
        //using currentPage to calculate condition based on recent feedback
        if (feedbackArray.length > 0) {
          const feedbackExists = some(feedbackArray, ["page", currentPage]);
          if (feedbackExists) {
            Object.keys(
              conditionIndex > -1
                ? condition[conditionIndex]
                : conditionPlaceholder
            ).map((key, i) => {
              let conditionExists = false;
              if (key !== "page") {
                conditionExists = some(feedbackArray, {
                  conditionType: key,
                  page: currentPage,
                });
                newCondition[key] = conditionExists;
              } else {
                newCondition[key] = currentPage;
              }
            });
          }
        }

        let newConditionArray = [];

        if (conditionIndex > -1) {
          newConditionArray = [...condition];
          newConditionArray[conditionIndex] = newCondition;
        } else {
          newConditionArray = [...condition, newCondition];
        }

        return {
          ...state,
          condition: newConditionArray,
        };
      } else {
        return state;
      }
    }

    case types.SAVE_RENDERED_COMPONENTS: {
      const { currentPage } = state;
      return {
        ...state,
        past: {
          ...state.past,
          [currentPage]: action.data,
        },
      };
    }

    case types.RESET_WIDGET: {
      return {
        sessionId: null,
        rateParam: null,
        user: {
          identification: null,
          loading: false,
          error: null,
        },
        widgetJSON: {
          isLinkActive: false,
          loading: false,
          error: null,
          data: null,
        },
        pages: null,
        maxPage: 0,
        currentPage: 0,
        buttonPressed: "",
        selectedLanguage: "en",
        formValues: null,
        feedbackArray: [],
        currentFeedbackScore: null,
        overallFeedbackScores: null,
        markpage: {
          show: false,
          data: null,
          serviceId: null,
          rate: null,
        },
        isMultiService: false,
        serviceIds: [],
        pageComponents: [],
      };
    }
    case types.SET_IS_ERROR_PAGE: {
      return {
        ...state,
        isErrorPage: true,
      };
    }
    case types.SET_BUTTONS_DISABLE: {
      return {
        ...state,
        buttonsDisable: action.data,
      };
    }
    case types.SET_SCROLL: {
      return {
        ...state,
        scroll: action.data,
      };
    }
    default:
      return state;
  }
};

const calculateCurrentScore = (feedbackArray, currentPage) => {
  const currentScore = reduce(
    feedbackArray,
    function (sum, n) {
      console.log(sum, RATE_SCORE[n.rate], n.rate);
      if (n.page === currentPage) {
        return RATE_SCORE[n.rate] + sum;
      }
    },
    null
  );

  return currentScore;
};

export default reducer;
